import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, DataTable } from "../../components";
import { Paper } from "@mui/material";
import MaskCPFCNPJ from "../../helpers/maskCpfCnpj";
import {
  KeyboardArrowLeftOutlined,
  KeyboardArrowRightOutlined,
} from "@mui/icons-material";
import formatName from "../../helpers/formatName";
import { formatCelular } from "../../helpers";
import ButtonComponent from "../../components/ButtonComponent";
import ModalAddEmpresa from "./cadastro/add";
import * as types from "../../store/types/modalidades";
import Loading from "../../components/Loading";
import { loadIntegradores } from "../../store/actions/parceiros_integracao";
import { useNavigate } from "react-router-dom";

function IntegradoresApp() {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const { parceiros_integracao, page, per_page, total } = useSelector(
    (state) => state.parceiros_integracao
  );
  const [filtro, setFiltro] = useState("");
  const [filtroAtualizado, setFiltroAtualizado] = useState("");
  const [openModalInformations, setOpenModalInformations] = useState(false);
  const [modalOpenAdd, setModalOpenAdd] = useState(false);
  const [loading, setLoading] = useState(false);

  async function GetDataLoad() {
    setLoading(true);
    const data = {
      page: page,
      per_page: per_page,
      filtro: filtroAtualizado,
      status: "A",
    };
    await loadIntegradores(data);
    setLoading(false);

    setFiltroAtualizado(""); // Limpa o estado após a requisição
  }

  const navigatePages = (validations) => {
    dispatch({ type: types.MODALIDADES_DATA_PAGE, payload: validations });
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (filtro === "") {
        GetDataLoad(); // Se filtro está vazio, chama a função GetDataLoad diretamente
      } else {
        setFiltroAtualizado(filtro);
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [filtro, page]);

  useEffect(() => {
    if (filtroAtualizado !== "") {
      GetDataLoad();
    }
  }, [filtroAtualizado, page]);



  const styledBtnArrows = {
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    border: "none",
    cursor: "pointer",
    margin: 15,
    backgroundColor: "transparent",
    fontFamily: "Poppins",
  };

  const columns = [
    { title: "Nome", render: ({ nome }) => formatName(nome) },
    { title: "CNPJ", render: ({ cnpj }) => MaskCPFCNPJ(cnpj) },
    { title: "Celular", render: ({ celular}) => formatCelular(celular) },
    { title: "E-mail", render: ({ email }) => email }  
  ];


  const handleRowClick = (event, rowData) => {
    navigate(`/app/parceiros/${rowData.id}`);
    // dispatch({ type: types.EMPRESA_SELECIONADA_USUARIOS, payload: rowData });
    setOpenModalInformations(true);
  };

  return (
    <div>
      <Loading loading={loading} />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <h4>Parceiros Integração</h4>
        <ButtonComponent onClick={() => setModalOpenAdd(true)}>
          Adicionar parceiros integração
        </ButtonComponent>
      </div>
      <Paper elevation={1} style={{ padding: 5 }}>
        <DataTable
          columns={columns}
          data={parceiros_integracao}
          enableHover={true}
          options={{
            defaultMessage: "Não há registros para serem exibidos.",
            rowStyle: { backgroundColor: "#ffffff", cursor: "pointer" },
            cellStyle: { border: "1px solid #ddd" },
          }}
          onRowClick={handleRowClick}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignContent: "center",
            alignItems: "center",
            fontFamily: "Poppins",
            fontSize: 14,
            justifyContent: "flex-end",
          }}
        >
          <div
            style={{ marginRight: 30, display: "flex", flexDirection: "row" }}
          >
            {+page !== 1 && (
              <button
                style={styledBtnArrows}
                onClick={() => navigatePages(+page - 1)}
              >
                <KeyboardArrowLeftOutlined /> Anterior{" "}
              </button>
            )}

            {parceiros_integracao?.length !== 0 && (
              <button
                style={styledBtnArrows}
                onClick={() => navigatePages(+page + 1)}
              >
                Próximo <KeyboardArrowRightOutlined />
              </button>
            )}
          </div>
          <p>
            Pagina <b>{page}</b> | Total de registros <b>{total}</b>
          </p>
        </div>
      </Paper>

      <ModalAddEmpresa
        open={modalOpenAdd}
        close={() => setModalOpenAdd(false)}
        updateList={() => GetDataLoad()}
      />
    </div>
  );
}

export default IntegradoresApp;
